import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ENDPOINTS } from '../constants';
import { Config } from '../models/config';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  private env: any;
  config!: Config;
  
  constructor(
    private http:HttpClient,
    public configService: ConfigService) {
  }

  load() {
    console.log(`${this.constructor.name} [load] ${ENDPOINTS.ENV}`)
    return this.http.get(ENDPOINTS.ENV.replace('{server}', this.configService.config.server_admin)).toPromise()
  }

  getEnv() {
    console.log(`[getEnv] env: `, this.env)
    return this.env;
  }

  setEnv(env: any) {
    console.log(`[setEnv] env: `, env)
    console.log(`[setEnv] env: ` + JSON.stringify(env))
    this.env = env
  }
}
